import * as React from 'react';
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews';
import { ParallaxProvider } from 'react-scroll-parallax';
import { config } from './prismic-preview-config.js';

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider repositoryConfigs={[ config ]}>
    <ParallaxProvider>
      {element}
    </ParallaxProvider>
  </PrismicPreviewProvider>
);
